import { z } from 'zod';

const imageDto = z.object({
  url: z.string().url(),
  alt: z.string().default(''),
});

export const pageSectionDto = z.object({
  id: z.union([z.string(), z.number()]).transform(String),
  key: z.string().nullable().default(null),
  title: z.string().default(''),
  text: z.string().default(''),
  tag: z.string().default(''),
  cta_label: z.string().default(''),
  link: z.string().nullable().default(null),
  bg_color: z.string().nullable().default(null),
  placement: z.union([
    z.enum([
      'after_hero', 'after_trust', 'after_categories', 'after_partners',
      'after_best_prices', 'after_new_arrivals', 'after_popular_products', 'after_news',
    ]),
    z.string().regex(/^after_category_[1-9]\d*$/).transform((value) => value as `after_category_${number}`),
  ]).default('after_partners'),
  layout: z.enum(['card', 'wide']).default('card'),
  row_key: z.string().nullable().default(null),
  show_in_categories_menu: z.boolean().default(false),
  categories_menu_order: z.number().int().default(0),
  sort_order: z.number().int().default(0),
  image: imageDto.nullable().default(null),
});

export const pageSectionListDto = z.object({ data: z.array(pageSectionDto) });

export type PageSectionDto = z.infer<typeof pageSectionDto>;
